<template>
  <GeojsonLayer :before="before" :layer="layerStyle" :source="source" :sourceId="sourceId" />
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import GeojsonLayer from '@/components/map/mapbox-layers/GeojsonLayer.vue'

export default {
  name: 'LayerBackground',
  components: {
    GeojsonLayer
  },
  data() {
    return {
      layerId: 'layer-background',
      sourceId: 'source-background',
      source: {
        type: 'geojson',
        data: {
          id: 'source-background',
          type: 'FeatureCollection',
          features: []
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isModelviewShowing: 'isModelviewShowing'
    }),
    ...mapState({
      mountedMapLayerIds: (state) => state.mountedMapLayerIds
    }),
    before() {
      if (this.mountedMapLayerIds.some((layer) => layer.startsWith('layer-orthophoto-floor'))) {
        const orthophotoLayers = this.mountedMapLayerIds.filter((layer) =>
          layer.startsWith('layer-orthophoto-floor')
        )
        return orthophotoLayers[0]
      }
      if (this.mountedMapLayerIds.some((layer) => layer.startsWith('layer-drawing-floor'))) {
        const drawingLayers = this.mountedMapLayerIds.filter((layer) =>
          layer.startsWith('layer-drawing-floor')
        )
        return drawingLayers[0]
      }
      if (this.mountedMapLayerIds.includes('layer-room-level-beneath'))
        return 'layer-room-level-beneath'
      return ''
    },
    layerStyle() {
      return {
        id: this.layerId,
        type: 'background',
        paint: {
          'background-color': '#EFEFEF'
        },
        layout: {
          visibility: this.isModelviewShowing ? 'visible' : 'none'
        }
      }
    }
  },
  watch: {
    before() {
      if (this.before.length) this.$store.map.moveLayer(this.layerId, this.before) // This is necessary for correct layer order when pasting a modelview link
    }
  }
}
</script>

<style scoped></style>
